export function formatCurrency(value) {
  return `R$ ${parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatNumber(value) {
  return parseFloat(value).toLocaleString('pt-BR');
}

export function calculateTop3ContributionPercentage(top3Value, totalValue) {
  const percentage = (top3Value / totalValue) * 100;
  const isValidValue =
    !isNaN(percentage) &&
    isFinite(percentage) &&
    top3Value > 0 &&
    totalValue > 0;
  if (isValidValue) {
    return `${percentage.toFixed(2)}%`;
  }
  return `0.00%`;
}

export function calculateKPITop3(top3Ranked) {
  const periodBilling = top3Ranked.reduce((sum, consultant) => {
    const value = parseFloat(
      consultant.valorPrimeiraParcela.replace(/R\$|\./g, '').replace(',', '.'),
    );
    return sum + value;
  }, 0);

  const periodSales = top3Ranked.reduce(
    (sum, consultant) => sum + consultant.totalVendas,
    0,
  );
  const ticketAverage = periodBilling / periodSales;

  return {
    periodBilling,
    periodSales,
    ticketAverage,
  };
}

export async function createTemporaryTables(services, dataSend, startDate, endDate) {
  const { data } = await services.post(
    'annual-podium',
    'createTemporaryTables',
    {
      startDate,
      endDate,
      ...dataSend,
    },
  );
  return data;
}

export async function dropTemporaryTables(services, temporaryTables) {
  await services.post(
    'painel-comercial',
    'dropTemporaryTables',
    temporaryTables,
  );
}
